import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';
import Form from '@appComponents/ReduxFormControls';
import {getBufferDropdownOptions} from '@modules/liveControl/utils/helpers';

const FORM_NAME = 'ArgosJobLiveControl';

export function ArgosJobLiveControlFiltersComponent({loading, restoreFilterValues, filters}) {
    const formFiltersValues = filters?.[FORM_NAME] || {};

    return (
        <div className='livecontrol__filters filter__controls__container'>
            <Field
                component={Form.ReduxSelect}
                name='preBuffer'
                className='preBuffer'
                placeholder='Pre-buffer'
                loading={loading}
                disabled={loading}
                options={getBufferDropdownOptions('-')}
                setValue={restoreFilterValues(formFiltersValues, 'preBuffer', 2)}
                allowClear={false}
            />
            <Field
                component={Form.ReduxSelect}
                name='postBuffer'
                className='postBuffer'
                placeholder='Post-buffer'
                loading={loading}
                disabled={loading}
                options={getBufferDropdownOptions('+')}
                setValue={restoreFilterValues(formFiltersValues, 'postBuffer', 2)}
                allowClear={false}
            />
        </div>
    );
}

ArgosJobLiveControlFiltersComponent.propTypes = {
    loading: PropTypes.bool,
    restoreFilterValues: PropTypes.func.isRequired,
    filters: PropTypes.object,
};

export default FiltersWrapper(ArgosJobLiveControlFiltersComponent, {
    name: FORM_NAME,
    initialValues: {
        preBuffer: 2,
        postBuffer: 2,
    },
});
